import { DexxButton } from "../light/LightButton"

export default function GenericPopup(props: 
        {children?: any, className?: string, closeFunction?: Function,
        handleSubmit?: Function}) : JSX.Element {
    return <>
        <div className="w-full lg:w-128 h-full font-roboto ">
            {props.children ? props.children : ""}
            <div className="flex justify-between px-4 lg:px-6 pb-2">
                {
                    props.closeFunction ?
                        <DexxButton onClick={() => {if(props.closeFunction) props.closeFunction()}} 
                            label={"close"} fontClasses="text-xs font-medium"
                            className="rounded-lg px-4 lg:px-8 md:py-3 py-2  drop-shadow-n" 
                            color1='gray8' color2='gray8' color3="gray7"/> :
                        <></>
                }
                {
                    props.handleSubmit ?
                        <DexxButton onClick={() => {if(props.handleSubmit) props.handleSubmit()}} 
                            label={"confirm"} fontClasses="text-xs  font-medium" 
                            className="rounded-lg px-4 lg:px-16 md:py-3 py-2" 
                            color1='primary' color2='primary' color3="primary_lightest"/> :
                        <></>
                }
            </div>
        </div>
    </>
}

export function PopupLabelAndValueInline(props: {label: string, 
        value: string | number | JSX.Element | undefined,
        className? : string}) : JSX.Element {
    return <>
        <div className=" flex gap-2">
            <div className="font-semibold text-primary uppercase">{props.label}</div>
            {props.value}
        </div>
    </>

}

export function PopupTitle(props: {color: string,
        className?: string, children?: any}) : JSX.Element {
    return <>
        <div className={"uppercase text-" + props.color + " text-base font-medium col-span-6"}>
                    {props.children}</div>
    </>
}

export function PopupText(props: {children?: any, className?: string}) {
    return <div className={"font-thin text-sm "+props.className}>{props.children}</div>
}